import { Component } from '@angular/core';
import { RouterConst } from '../../globals/RoutersConst';
import { BreadcrumbService } from '../../breadcrumb.service';
import { DashboardDataService } from '../../services/dashboard-data.service';
import { SuperClass } from '../../superclass/SuperClass';
import { ClientsService } from '../../services/clients/clients.service';
import { WsService } from '../../services/websocket/WsService';
import { WsConst } from '../../globals/WsConst';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {map} from "rxjs/operator/map";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
})
export class UsersComponent extends SuperClass {
  dashboardData: any;

  uniqueUsers: any;
  deviceType: any;
  chartOptions: any;
  osType: any;
  browsers;
  sparkOsType: any;
  sparkPieUsersNewVsRet: any;
  sparkDeviceType: any;
  sparkBrowsersType: any;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      {
        label: 'Users',
        routerLink: [{ outlets: { sub: [RouterConst.USERS] } }],
      },
    ]);
  }

  setData(data) {
    this.dashboardData = data;
    this.chartsInit();
  }

  reloadData() {
    this.dashboardDataService.getDD('UsersComponent');
  }

  getWebSocketIdentifier() {
    return WsConst.STATISTICS;
  }

  splitToTime(spark:any):any[] {
    console.log(spark);
    let arraySplit: number[];
    let data = spark.data.map(Number);
    arraySplit = [data[0] + data[1] + data[2] + data[3] + data[4],
      data[5], data[6], data[7], data[8], data[9],
      data[10], data[11], data[12], data[13], data[14],
      data[15], data[16], data[17], data[19], data[20],
      data[21], data[22] + data[23],
    ];
    console.log(arraySplit);
    return arraySplit;
  }

  chartsInit() {
    this.chartOptions = {
      scaleFontColor: 'gray',

      legend: {
        labels: {
          fontColor: 'gray',
        },
      },

      scales: {
        xAxes: [
          {
            gridLines: {
              color: 'gray',
              display: false,
            },
            stacked: true,
          },
        ],

        yAxes: [
          {
            scaleLabel: {
              display: true,
              // labelString: 'Load in %',
              fontColor: 'gray',
            },
            gridLines: {
              color: 'gray',
              display: true,
            },
            stacked: true,
          },
        ],
      },
    };
    this.uniqueUsers = {
      labels: [
        '0-6am',
        '6am',
        '7am',
        '8am',
        '9am',
        '10am',
        '11am',
        'Noon',
        '1pm',
        '2pm',
        '3pm',
        '4pm',
        '5pm',
        '6pm',
        '7pm',
        '8pm',
        '9pm',
        '> 10pm',
      ],
      datasets: [
        {
          label: 'New user',
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          data: this.splitToTime(this.dashboardData.charts.sparkNewUsers)
        },
        {
          label: 'Returning user',
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          data:  this.splitToTime(this.dashboardData.charts.sparkRetUsers),
        },
      ],
    };

    this.sparkPieUsersNewVsRet = {
      labels: ['New for period', 'Returning for period'],
      datasets: [
        {
          data: this.dashboardData.charts.sparkPieUsersNewVsRet.data,
          backgroundColor: ['#F6BD60', '#488BB4'],
          hoverBackgroundColor: ['#FFE082', '#81D4FA'],
        },
      ],
    };
    this.deviceType = {
      labels: ['PC', 'MAC', 'Tablet', 'iPhone', 'Android Phone', 'Other'],
      datasets: [
        {
          label: 'New User',
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          order: 1,
          data: this.dashboardData.charts.deviceType.data1,
        },
        {
          label: 'Returning User',
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          order: 2,
          data: this.dashboardData.charts.deviceType.data2,
        },
      ],
    };
    this.sparkDeviceType = {
      labels: ['New for period', 'Returning for period'],
      datasets: [
        {
          data: this.dashboardData.charts.sparkPieDeviceNewVsRet.data,
          backgroundColor: ['#F6BD60', '#488BB4'],
          hoverBackgroundColor: ['#FFE082', '#81D4FA'],
        },
      ],
    };
    this.osType = {
      labels: ['iOS', 'OSX', 'Windows', 'Android', 'Other'],
      datasets: [
        {
          label: 'New User',
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          order: 1,
          data: this.dashboardData.charts.osType.data1,
        },
        {
          label: 'Returning User',
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          order: 2,
          data: this.dashboardData.charts.osType.data2,
        },
      ],
    };
    this.sparkOsType = {
      labels: ['New for period', 'Returning for period'],
      datasets: [
        {
          data: this.dashboardData.charts.sparkPieOSNewVsRet.data,
          backgroundColor: ['#F6BD60', '#488BB4'],
          hoverBackgroundColor: ['#FFE082', '#81D4FA'],
        },
      ],
    };
    this.browsers = {
      labels: [
        'Chrome',
        'Firefox',
        'Explorer',
        'Edge',
        'Safari',
        'Opera',
        'Other',
      ],
      datasets: [
        {
          label: 'New User',
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          order: 1,
          data: this.dashboardData.charts.browserType.data1,
        },
        {
          label: 'Returning User',
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          order: 2,
          data: this.dashboardData.charts.browserType.data2,
        },
      ],
    };
    this.sparkBrowsersType = {
      labels: ['New for period', 'Returning for period'],
      datasets: [
        {
          data: this.dashboardData.charts.sparkPieBrowserNewVsRet.data,
          backgroundColor: ['#F6BD60', '#488BB4'],
          hoverBackgroundColor: ['#FFE082', '#81D4FA'],
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/users/users.component.ts